import { CSSProperties, useState } from "react";
import { featureTabsArr, platefromTabsArr, sportTabsArr } from "./constants";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";

export function InternalDashboardHeader({
  headerTitle,
  selectedTab,
  activeSportType,
  setActiveSportType,
  activePlateform,
  setActivePlateform,
  activeFeature,
  setActiveFeature,
}: any) {
  return (
    <div
      className={styles.internalHeaderContainer}
      style={
        { marginBottom: selectedTab === "tickets" && "30px" } as CSSProperties
      }
    >
      <div className={styles.headerTop}>
        <div className={styles.dashbordBtn}>{headerTitle}</div>
        {/* <DurationTabs /> */}
        <ConditionalRenderer condition={selectedTab !== "tickets"}>
          <div className={styles.sportTypeTabs}>
            {sportTabsArr.map((state: any) => {
              const BtnIcon = state.icon;
              return (
                <button
                  key={state.key}
                  type="button"
                  onClick={() => setActiveSportType(state.key)}
                  className={
                    activeSportType === state?.key ? styles.activeSportType : ""
                  }
                >
                  <BtnIcon active={activeSportType === state?.key} />
                  {state.label}
                </button>
              );
            })}
          </div>
        </ConditionalRenderer>
      </div>
      <ConditionalRenderer condition={selectedTab !== "tickets"}>
        <div className={styles.headerTabsContainer}>
          <div className={styles.plateformTabs}>
            <div className={styles.text}>Choose platform</div>
            {platefromTabsArr.map((state: any) => {
              const BtnIcon = state.icon;
              return (
                <button
                  key={state.key}
                  type="button"
                  onClick={() => setActivePlateform(state.key)}
                  className={
                    activePlateform === state?.key ? styles.activePlateform : ""
                  }
                >
                  <BtnIcon
                    fill={
                      activePlateform === state?.key
                        ? "white"
                        : state?.inActiveFill
                    }
                  />
                  {state.label}
                </button>
              );
            })}
          </div>
          <ConditionalRenderer condition={activeSportType === "golf"}>
            <div className={styles.featureTabs}>
              <div className={styles.text}>Feature</div>
              {featureTabsArr.map((state: any) => {
                const BtnIcon = state.icon;
                return (
                  <button
                    key={state.key}
                    type="button"
                    onClick={() => setActiveFeature(state.key)}
                    className={
                      activeFeature === state?.key ? styles.activePlateform : ""
                    }
                  >
                    <BtnIcon active={state?.key === activeFeature} />
                    {state.label}
                  </button>
                );
              })}
            </div>
          </ConditionalRenderer>
        </div>
      </ConditionalRenderer>
    </div>
  );
}
